import FollowupList from "./pages/FollowupList";
import VerticalGuard from "../../../components/common/VerticalGuard";
import FollowupEdit from "./pages/FollowupEdit";

const followupRoutes = [
  {
    path: "/:vertical/followups",
    element: (
      <VerticalGuard>
        <FollowupList />
      </VerticalGuard>
    ),
  },
  {
    path: "/:vertical/followups/:id/edit",
    element: (
      <VerticalGuard>
        <FollowupEdit />
      </VerticalGuard>
    ),
  }
];

export default followupRoutes;